import { Outlet, Link } from 'react-router-dom';
import Footer from './Footer';
import './Layout.css';

function Layout() {
  return (
    <div className="layout">
      <header className="site-header">
        <Link to="/" className="logo">KeepOrDel</Link>
        <nav className="nav">
          <Link to="/">Home</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms">Terms & Conditions</Link>
        </nav>
      </header>
      <main className="main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
